import React from "react";

/**
 * 渲染统一的数据手册图标。
 * @param {{ className?: string }} props 组件属性
 * @returns {React.JSX.Element} 数据手册装饰图标
 */
const DatasheetIcon = ({ className = "w-6" }) => (
  <img
    src="/img/datasheet-icon.png"
    alt=""
    aria-hidden="true"
    className={`block h-auto ${className}`}
  />
);

export default DatasheetIcon;
